export default {
    data() {
        return {
            rights: {}
        };
    },
    methods: {
        registerRights(response) {
            this.rights = response.json._embedded.rights;
        },
        reRegisterRights(rights) {
            this.rights = rights;
        },
        checkRight(right = "read") {
            if (this.rights[right]) {
                return this.rights[right];
            }
            return false;
        }
    }
};
